module.exports = __webpack_public_path__ + "img/training-walk.488be248.svg";